import { format, parse } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { DateFormats, dateFormats } from '~constants/date'

interface FormatDateArgs {
    date?: Date | string
    formatType?: DateFormats
    formatString?: string
    is12hourFormat?: boolean
    tz?: string
}

export const formatDate = ({
    date,
    formatType = 'dateTime',
    is12hourFormat,
    formatString,
    tz,
}: FormatDateArgs): string => {
    if (!date) {
        return ''
    }

    const formatStr = formatString || dateFormats[formatType][is12hourFormat ? 'f12' : 'f24']
    const dateObj = typeof date === 'string' ? Date.parse(date) : parse('', '', date)

    if (tz) {
        return formatInTimeZone(dateObj, tz, formatStr)
    }

    return format(dateObj, formatStr)
}
